module.exports = __webpack_public_path__ + "img/1-sdg-border@2x.2267cb62.png";